import { fetchFactory } from 'isotope-client'

export const getUsersByQuery = (query: string) => fetchFactory(`/users/query?query=${query}`)

export const updateUserLanguage = (language: string) => fetchFactory('/utilisateurs/langue', { method: 'PUT' , body: JSON.stringify({ langue: language })})
